import { Route, Switch } from 'react-router-dom';
import { NavWrapper, StyledSubNavigation } from './styles';
import { subroutes } from './subroutes';
import { usePreReleaseFeatures } from 'hooks/usePreReleaseFeatures';
import { useMemo } from 'react';
import { useBillingPermissions } from 'ts-components/hooks/permissions/billing';

export default function BillingPage({ access, location }) {
  const preReleaseFeatures = usePreReleaseFeatures();

  const routes = useMemo(() => {
    return subroutes(preReleaseFeatures);
  }, [preReleaseFeatures]);

  const billingPermission = useBillingPermissions();

  return (
    <>
      <NavWrapper className="nav-wrapper">
        <StyledSubNavigation
          small
          id="sectionnav"
          routes={routes}
          currentSearch={location.search}
        />
      </NavWrapper>
      <Switch>
        {Object.entries(routes)
          .map(([key, route]) => {
            const Component = route.component;
            const hasPermission =
              route?.access?.checkBillingPermission?.(billingPermission);

            if (!hasPermission) {
              return null;
            }

            return (
              <Route
                key={key}
                path={route.path}
                exact={route.exact !== false}
                component={route.component}
              >
                <Component access={access} />
              </Route>
            );
          })
          .filter(Boolean)}
      </Switch>
    </>
  );
}
